// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".via-local-header-row{display:grid;grid-template-columns:50% 50%;transition:.5s;padding:8px 0}.via-local-header-col{text-align:center;padding:.5em 0;display:flex;align-items:center;justify-content:center;position:relative;cursor:pointer}.local-state-text{padding-bottom:3px}.local-active .local-state-text{border-bottom:2px solid #464646}", ""]);
// Exports
module.exports = exports;
